import React from "react";

interface StatusBadgeProps {
  status: string;
  className?: string;
}

/**
 * StatusBadge Component
 * 
 * A reusable badge component for displaying status with appropriate color coding
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = "" }) => {
  const getStatusBadgeClass = (status: string) => {
    switch (status.toLowerCase()) {
      case "new":
        return "bg-blue-100 text-blue-800";
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "shipping":
        return "bg-sky-100 text-sky-800";
      case "delivered":
      case "completed":
        return "bg-green-100 text-green-800";
      case "cancelled":
        return "bg-red-100 text-red-800";
      case "latemarking":
      case "latepickup":
        return "bg-amber-100 text-amber-800";
      case "processing":
        return "bg-purple-100 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <span
      className={`px-2.5 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeClass(
        status
      )} ${className}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
